const MONTH_ABBR = {
  Jan: "January",
  Feb: "February",
  Mar: "March",
  Apr: "April",
  May: "May",
  Jun: "June",
  Jul: "July",
  Aug: "August",
  Sep: "September",
  Oct: "October",
  Nov: "November",
  Dec: "December",
};

export const TIER_COLORS = {
  Strong: "#4ADE80",
  Growing: "#60A5FA",
  "Need Support": "#F87171",
};

export const TIER_SUBTITLES = {
  Strong: "students \u2265 85%",
  Growing: "students 65\u201384%",
  "Need Support": "students < 65%",
};

export const PERIOD_OPTIONS = [
  { value: "day", label: "Day" },
  { value: "week", label: "Week" },
  { value: "month", label: "Month" },
];

// "Sep '25" → "September 2025"
// "Jan W2"  → "January, Week 2"
// "Feb 20"  → "February 20"
export function formatTooltipTitle(label, period) {
  const monthMatch = label.match(/^(\w{3})\s+'(\d{2})$/);
  if (period === "month" && monthMatch) {
    const [, mon, yr] = monthMatch;
    return `${MONTH_ABBR[mon] || mon} 20${yr}`;
  }
  const weekMatch = label.match(/^(\w{3})\s+W(\d+)$/);
  if (period === "week" && weekMatch) {
    const [, mon, w] = weekMatch;
    return `${MONTH_ABBR[mon] || mon}, Week ${w}`;
  }
  const dayMatch = label.match(/^(\w{3})\s+(\d+)$/);
  if (period === "day" && dayMatch) {
    const [, mon, day] = dayMatch;
    return `${MONTH_ABBR[mon] || mon} ${day}`;
  }
  return label;
}
